/* TBM theme JS — adapted from mdn-theme.js (MDN live, 2026-07-07).
   AJAX cart drawer + toast + nav behaviors. Injected sizes converted to px (10px-root theme). */
(function () {
  "use strict";
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  let toastTimer;
  window.mdnShowToast = function (msg) {
    let toast = $("#mdn-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "mdn-toast";
      toast.className = "mdn-toast";
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 3000);
  };

  function formatMoney(cents) { return "$" + (cents / 100).toFixed(2); }

  function refreshCartDrawer() {
    fetch("/cart.js").then(r => r.json()).then(cart => {
      const countEl = $("#mdn-cart-count");
      if (countEl) { countEl.textContent = cart.item_count; countEl.dataset.count = cart.item_count; }
      const body = $("#mdn-cart-body");
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<p class="mdn-cart-drawer__empty">Your cart is empty.</p>';
        const oldSub = $(".mdn-cart-drawer__subtotal");
        if (oldSub) oldSub.remove();
      } else {
        body.innerHTML = cart.items.map((item, idx) => {
          let imgSrc = "";
          if (item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;
          else if (item.image) imgSrc = item.image;
          if (imgSrc) imgSrc = imgSrc.replace(/(\.jpg|\.jpeg|\.png|\.webp|\.gif)(?=\?|$)/i, "_120x120$1");
          const showVariant = item.variant_title && item.variant_title !== "null" && item.variant_title !== "Default Title" && item.variant_title.trim() !== "";
          return `
            <div class="mdn-cart-item">
              <div class="mdn-cart-item__img">
                ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy" onerror="this.style.display='none'">` : '<div style="width:64px;height:64px;background:var(--sand);border-radius:4px;"></div>'}
              </div>
              <div style="flex:1;min-width:0;">
                <p class="mdn-cart-item__name">${item.product_title}</p>
                ${showVariant ? `<p style="font-size:12.5px;color:var(--muted);margin-bottom:3px;">${item.variant_title}</p>` : ""}
                <p class="mdn-cart-item__price">Qty ${item.quantity} &times; ${formatMoney(item.price)}</p>
                <button class="mdn-cart-item__remove" data-line="${idx + 1}">Remove</button>
              </div>
              <div style="font-weight:700;color:var(--navy);white-space:nowrap;flex-shrink:0;">${formatMoney(item.line_price)}</div>
            </div>`;
        }).join("");
        const footer = $(".mdn-cart-drawer__footer");
        if (footer) {
          const subtotalHtml = `<div class="mdn-cart-drawer__subtotal"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>`;
          const existing = footer.querySelector(".mdn-cart-drawer__subtotal");
          if (existing) existing.outerHTML = subtotalHtml;
          else footer.insertAdjacentHTML("afterbegin", subtotalHtml);
        }
        $$(".mdn-cart-item__remove").forEach(btn => {
          btn.addEventListener("click", function () {
            fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: parseInt(this.dataset.line), quantity: 0 }) })
              .then(() => refreshCartDrawer());
          });
        });
      }
    });
  }

  function openCart() {
    const drawer = $("#mdn-cart-drawer"), overlay = $("#mdn-cart-overlay");
    if (drawer) drawer.classList.add("is-open");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    refreshCartDrawer();
  }
  function closeCart() {
    const drawer = $("#mdn-cart-drawer"), overlay = $("#mdn-cart-overlay");
    if (drawer) drawer.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  window.mdnOpenCart = openCart;
  window.mdnRefreshCartDrawer = refreshCartDrawer;

  const cartToggle = $("#mdn-cart-toggle");
  if (cartToggle) cartToggle.addEventListener("click", function (e) {
    if ($("#mdn-cart-drawer")) { e.preventDefault(); openCart(); } /* no-JS/no-drawer fallback: link goes to /cart */
  });
  const cartClose = $("#mdn-cart-close");
  if (cartClose) cartClose.addEventListener("click", closeCart);
  const cartOverlay = $("#mdn-cart-overlay");
  if (cartOverlay) cartOverlay.addEventListener("click", closeCart);

  const searchToggle = $("#mdn-search-toggle"), searchBar = $("#mdn-search-bar");
  if (searchToggle && searchBar) searchToggle.addEventListener("click", function () {
    const open = searchBar.classList.toggle("is-open");
    this.setAttribute("aria-expanded", open);
    searchBar.setAttribute("aria-hidden", !open);
    if (open) { const inp = searchBar.querySelector("input"); if (inp) inp.focus(); }
  });

  const hamburger = $("#mdn-hamburger"), mobileNav = $("#mdn-mobile-nav"), mobileClose = $("#mdn-mobile-close");
  function closeMobileNav() {
    if (mobileNav) { mobileNav.classList.remove("is-open"); mobileNav.setAttribute("aria-hidden", "true"); }
    if (hamburger) hamburger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  if (hamburger) hamburger.addEventListener("click", function () {
    if (mobileNav) { mobileNav.classList.add("is-open"); mobileNav.setAttribute("aria-hidden", "false"); }
    this.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  });
  if (mobileClose) mobileClose.addEventListener("click", closeMobileNav);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeMobileNav(); closeCart();
      if (searchBar && searchBar.classList.contains("is-open")) {
        searchBar.classList.remove("is-open");
        searchBar.setAttribute("aria-hidden", "true");
        if (searchToggle) searchToggle.setAttribute("aria-expanded", "false");
      }
    }
  });

  /* Collection-card quick add: AJAX + toast + drawer (form submit is the no-JS fallback) */
  $$(".mdn-atc-btn").forEach(btn => {
    btn.addEventListener("click", function (e) {
      const id = this.dataset.productId, title = this.dataset.productTitle;
      if (!id) return;
      e.preventDefault();
      this.textContent = "Adding...";
      this.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: parseInt(id), quantity: 1 }) })
        .then(r => { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(item => {
          this.textContent = "Added!";
          window.mdnShowToast("Added to cart: " + (title || item.title));
          setTimeout(() => { this.textContent = "Add to Cart"; this.disabled = false; }, 2000);
          openCart();
        })
        .catch(() => { this.textContent = "Error — Try Again"; this.disabled = false; });
    });
  });

  /* Product page: intercept ATC form → AJAX + drawer (falls back to normal POST without JS) */
  /* M-01 port from MDN: shared in-flight lock. The main button, the sticky-bar button and
     Buy It Now all drive this form — a rapid double click (sticky bar calls requestSubmit
     with nothing disabled) fired two /cart/add.js requests and added 2 units. The lock lives
     on window so the product section's inline JS (Buy It Now) shares it. */
  const atcForm = $("#tbm-atc-form");
  if (atcForm) atcForm.addEventListener("submit", function (e) {
    if (!$("#mdn-cart-drawer")) return; /* no drawer markup → let the normal POST happen */
    e.preventDefault();
    if (window.tbmAtcInFlight) return;
    window.tbmAtcInFlight = true;
    const btn = $("#tbm-atc-btn");
    if (btn) { btn.disabled = true; }
    fetch("/cart/add.js", { method: "POST", body: new FormData(atcForm) })
      .then(r => { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(item => {
        window.mdnShowToast("Added to cart: " + item.title);
        openCart();
        /* M-01: stay locked briefly past the response so the trailing click of a
           double-click cannot re-submit; then release button + lock together. */
        setTimeout(() => { if (btn) btn.disabled = false; window.tbmAtcInFlight = false; }, 600);
      })
      .catch(() => { if (btn) btn.disabled = false; window.tbmAtcInFlight = false; atcForm.submit(); });
  });

  /* Active nav link + header shadow on scroll */
  const path = window.location.pathname;
  $$(".mdn-nav__link").forEach(link => { if (link.getAttribute("href") === path) link.classList.add("mdn-nav__link--active"); });
  const header = $(".mdn-header");
  if (header) window.addEventListener("scroll", function () {
    header.style.boxShadow = window.scrollY > 10 ? "0 2px 20px rgba(24,42,31,0.35)" : "";
  }, { passive: true });
})();

/* Premium motion: scroll reveals + image fade-in (exact port of MDN live inline script; selectors extended to tbm classes). Additive, fails silent. */
(function () {
  try {
    var revealTargets = document.querySelectorAll('.tbm-hp__categories .tbm-hp__cat-tile, .tbm-hp__prod-card, .mdn-prod-card, .mdn-related__card, .tbm-hp__story-inner, .tbm-hp__reviews-grid, .tbm-hp__visit-info, .mdn-about-section, .tbm-hp__section-header, .tbm-hp__arrivals-header, .mdn-about-stats > div');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealTargets.forEach(function (el, i) {
        el.classList.add('mdn-reveal');
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        io.observe(el);
      });
    }
    document.querySelectorAll('.mdn-prod-img img, .tbm-hp__prod-img-wrap img, .tbm-hp__cat-img img, .mdn-related__img img, .mdn-product__main-img img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); }
      else { img.addEventListener('load', function () { img.classList.add('is-loaded'); }); img.addEventListener('error', function () { img.classList.add('is-loaded'); }); }
    });
  } catch (e) { /* never block the page */ }
})();
